export default __webpack_public_path__ + "static/media/minesurfer-TN.961fdff5.png";